





























































import { Component, Vue } from "vue-property-decorator";
import Spinner from "@/components/Spinner.vue";
import Form from "@/components/Form.vue";
import Product from "@/components/Product.vue";
import Error from "@/components/Error.vue";
import { ProductFormData } from "../interfaces";
import { ProductInfo, scanQRCode, submitFormPost } from "../api";
import { getFullAddress } from "@/utils/googleMaps";
import { isErrorCode } from "@/utils";
import { getDeviceInfo } from "@/utils/info";

@Component({
  components: { Spinner, Form, Product, Error }
})
export default class Home extends Vue {
  productInfo: ProductInfo | null = null;
  token = "";
  dialog = false;
  submittedDialog = false;
  networkError: string | null = null;

  async created() {
    const qrcode = this.$route.query.qr as string;
    if (qrcode) {
      const address = await getFullAddress();
      const deviceInfo = await getDeviceInfo(navigator.userAgent);
      try {
        const result = await scanQRCode(qrcode, address, deviceInfo);
        this.productInfo = result.data;
        this.token = (this.isAllowSubmission && result.data.token) || "";
      } catch (e) {
        this.networkError = e.message;
      }
    }
  }

  async submitForm(formData: ProductFormData) {
    const formRequest = { ...formData, points: this.productInfo?.points || 0 };
    await submitFormPost(formRequest, this.token);
    if (this.productInfo?.royalty === "Y" && !!this.productInfo?.urlRoyalty) {
      this.dialog = true;
    }
  }

  agreeDialog(agree: boolean) {
    this.dialog = false;
    if (agree) {
      window.location.href = this.productInfo?.urlRoyalty || "";
    } else {
      this.submittedDialog = true;
    }
  }

  get hasError() {
    return isErrorCode(this.productInfo?.logStatus || "");
  }

  get hasNetworkError() {
    return !!this.networkError;
  }

  get isFirstTime() {
    return this.productInfo?.logStatus === "1";
  }

  get isAllowSubmission() {
    return this.isFirstTime && this.productInfo?.register == "1";
  }
}
